import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
const pains = [{
  emoji: '😰',
  text: 'Sentís que te morís cuando te agarra el pánico y no sabés qué hacer en el momento'
}, {
  emoji: '🌙',
  text: 'Te despertás a las 3 AM con el corazón acelerado sin motivo aparente'
}, {
  emoji: '🚇',
  text: 'Evitás el transporte, el super o el trabajo porque tenés miedo de que te agarre afuera'
}, {
  emoji: '😶',
  text: "Nadie en tu entorno entiende lo que te pasa y te dicen que 'te relajes' o que 'es todo mental'"
}, {
  emoji: '💊',
  text: 'Ya probaste medicación, respirar hondo y pensar positivo — y nada funcionó de verdad'
}, {
  emoji: '🔁',
  text: 'Mejorás un poco, y después volvés a empezar desde cero como si nada hubiera servido'
}];
export function PainSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-6 px-4 bg-primary" ref={ref} data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-102">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-103">
            ¿Te reconocés en alguna de estas situaciones?
          </h2>
          <p className="text-text-secondary text-sm sm:text-base" data-id="element-104">
            Si dijiste que sí aunque sea a una, este pack fue creado exactamente
            para vos.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5" data-id="element-105">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.9
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-card rounded-lg p-4 text-center border border-white/5 hover:border-accent-gold/30 transition-colors" data-id="element-106">
              <span className="text-3xl block mb-2" data-id="element-107">{pain.emoji}</span>
              <p className="text-white text-xs sm:text-sm leading-snug" data-id="element-108">
                {pain.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-109">
          <p className="text-white italic text-sm sm:text-base text-center max-w-[680px] mx-auto pt-3 border-t border-card" data-id="element-110">
            "El problema no sos vos. Es que nadie te dio las herramientas
            correctas — hasta ahora."
          </p>
        </motion.div>
      </div>
    </section>;
}